import { ItemContainerCreator } from "./item-container-creator";
import { GraphicCanvas, FixedDimension, PercentDimension } from "../../../../../web-graphics";

export class CanvasCreator extends ItemContainerCreator {
  // viewObjectCreators: new Map()
  constructor(commonSettings, viewObjectCreators, idGenerator) {
    super(commonSettings);
    this.viewObjectCreators = viewObjectCreators;
    this.idGenerator = idGenerator;
  }

  static prepareSettings(settings) {
    let canvasWidth = settings.width.copy();
    let canvasHeight = settings.height.copy();
    settings.location = {
      x: settings.x?.copy() ?? new FixedDimension(0),
      y: settings.y?.copy() ?? new FixedDimension(0)
    };
    settings.size = {
      width: settings.width?.copy() ?? new PercentDimension(1),
      height: settings.height?.copy() ?? new PercentDimension(1)
    };
    settings.parent = {
      size: {
        width: settings._parentWidth,
        height: settings._parentHeight
      }
    };
    settings.htmlObject = {
      location: {
        x: settings.x,
        y: settings.y
      },
      size: {
        width: canvasWidth,
        height: canvasHeight
      },
      parent: {
        ref: settings._parentHtmlObject,
        size: {
          width: settings._parentWidth,
          height: settings._parentHeight
        }
      }
    };
  }

  static createItems(settings, viewObjectCreators, canvasObject, idGenerator, creator) {
    if (settings === undefined || !Array.isArray(settings)) {
      return;
    }
    let calllbackArray = creator.callbacks.get("beforeAddItems");
    calllbackArray.forEach(callback => callback(canvasObject, settings, creator));
    for (let itemIndex = 0; itemIndex < settings.length; itemIndex++) {
      ItemContainerCreator.createItem(settings[itemIndex], viewObjectCreators, canvasObject, canvasObject, idGenerator, item => {
        canvasObject.addItem(item);
      });
    }
  }

  create(settings) {
    let calllbackArray = this.callbacks.get("beforeCreate");
    calllbackArray.forEach(callback => callback(settings, this));
    CanvasCreator.prepareSettings(settings);
    const canvas = new GraphicCanvas(settings);
    CanvasCreator.createItems(settings.items, this.viewObjectCreators, canvas, this.idGenerator, this);
    calllbackArray = this.callbacks.get("afterCreate");
    calllbackArray.forEach(callback => callback(canvas, settings, this));
    return canvas;
  }
}
